<template>
  <div class="home-page page">
    <div class="page-wrap" v-if="displayPage">
      <!-- 顶部 -->
      <page-top @selectData="fetchData"></page-top>
      <!-- 头部 -->
      <Header></Header>

      <!-- 主体 -->
      <main class="main w">
        <div class="newsBlock">
          <!-- 轮播图 -->
          <div class="news-cover">
            <banner :list="bannerList"></banner>
          </div>
          <div class="news-content">
            <div class="title">
              <div v-for="(item, index) in titles" :key="index" @mouseover="showList(item.id)" @click="toLink(item.code,item.tabcode)" :class="['title-item', { 'title-selected': item.isSelected }]">
                {{ item.title }}
              </div>
            </div>
            <div class="new-list" v-if="showNewList1">
              <div class="news-item" v-for="(item, index) in newsList1.list" :key="index" @click="toDetail(item,newsList1.categoryCode)">
                <div class="news-title">
                  {{ item.articleName }}
                </div>
                <div class="news-time">
                  {{ item.releaseTime }}
                </div>
              </div>
            </div>
            <div class="new-list" v-if="showNewList2">
              <div class="news-item" v-for="(item, index) in newsList2.list" :key="index" @click="toDetail(item,newsList2.categoryCode)">
                <div class="news-title">
                  {{ item.articleName }}
                </div>
                <div class="news-time">
                  {{ item.releaseTime }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="foot-banner">
        </div>

        <div class="noticeBolock">
          <div class="listBlock">
            <div class="list-header" @click="toLink(policyList.categoryCode)">
              <div class="list-title">政策文件</div>
            </div>
            <div class="list-content">
              <list-item :list="policyList" type="spot" @toDetail="toDetail"></list-item>
            </div>
          </div>
          <div class="listBlock">
            <div class="list-header" @click="toLink(jobList.categoryCode)">
              <div class="list-title">赛事活动</div>
            </div>
            <div class="list-content">
              <list-item :list="jobList" type="spot" @toDetail="toDetail"></list-item>
            </div>
          </div>
          <div class="listBlock">
            <div class="list-header" @click="toLink(teachList.categoryCode)">
              <div class="list-title">产教融合</div>
            </div>
            <div class="list-content">
              <list-item :list="teachList" type="spot" @toDetail="toDetail"></list-item>
            </div>
          </div>
          <div class="listBlock">
            <div class="list-header" @click="toLink(buildList.categoryCode)">
              <div class="list-title">党建工作</div>
            </div>
            <div class="list-content">
              <list-item :list="buildList" type="spot" @toDetail="toDetail"></list-item>
            </div>
          </div>
        </div>
        <!-- 红色标题 -->
        <div class="bannerBlock" :style="styleObject">
          <span>以产教融合&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 促进高质量充分就业</span>
        </div>
        <div class="professorBlock">
          <div class="professor-header">专家顾问</div>
          <div class="professor-content">
            <img class="item-detail" v-for="(item, index) in teacherList" :key="index" :src="$globalHeader.fileUrl + item.avatarUrl + item.avatarName" @click="teacherDetail(item.id)" />
          </div>
        </div>

        <div class="cooperatorBlock">
          <div class="coop-header">合作单位</div>
          <div class="coop-list">
            <a class="coop-item" v-for="(item, index) in coopList" :key="index" :href="item.unitUrl" target="_blank">
              <img class="img" :src="item.unitLogo" alt="" />
            </a>
          </div>
        </div>
      </main>
      <!-- 底部 -->
      <Footer></Footer>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Banner from "@/components/common/banner.vue";
import listItem from "@/components/list/list-item.vue";

import { getBannerList } from "@/api/common/common.js";
import {
  getArticlePage,
  getTeacherPage,
  getCooperateUnitPage,
} from "@/api/home/home.js";

const codeTargetMapping = {
  "202": "newsList1",
  "203": "newsList2",
  "701": "policyList",
  "401": "jobList",
  "501": "teachList",
  "1001": "buildList"
};

export default {
  components: {
    pageTop,
    Header,
    Footer,
    Banner,
    listItem,
  },
  data() {
    return {
      displayPage: true,
      loading: false,
      newsList1: [],
      newsList2: [],
      titles: [
        { id: 1, title: "本会活动", isSelected: false, code: '202', tabcode: '201' },
        { id: 2, title: "通知公告", isSelected: false, code: '203', tabcode: '201' },
      ],
      showNewList1: false,
      showNewList2: false,
      noticeList: [],
      policyList: [], //政策文件
      jobList: [], //结业创业
      teachList: [], //产教融合
      buildList: [], //党建工作
      teacherList: [],
      coopList: [],
      bannerList: [], //轮播图列表
    };
  },
  created() {
    this.fetchData();
  },
  computed: {
    styleObject() {
      return {
        backgroundImage: `url(${this.$globalHeader.fileUrl}/static/xmdch/yx/2.png)`,
      };
    },
    publicizeObject() {
      return {
        backgroundImage: `url(${this.$globalHeader.fileUrl}/static/xmdch/yx/4_1.png)`,
      };
    },
  },
  methods: {
    //统一获取数据
    fetchData() {
      getBannerList("1").then((res) => {
        this.bannerList = res.data;
      });
      //遍历映射关系，调用fetchNews方法
      Object.keys(codeTargetMapping).forEach(code => {
        this.fetchNews(code, codeTargetMapping[code]);
      });

      this.showList(0);
      this.newsList1 = this.noticeList;
      this.teacherPage();
      this.cooperateUnitPage();
    },
    fetchNews(code, target) {
      let params = {
        categoryCode: code,
        page: 1,
        limit: 6,
      };

      getArticlePage(params).then((res) => {
        this[target] = res.data;
      });
    },
    teacherPage() {
      let params = {
        page: 1,
        limit: 4,
      };

      getTeacherPage(params).then((res) => {
        this.teacherList = res.data.list;
      });
    },
    cooperateUnitPage() {
      let params = {
        page: 1,
        limit: 10,
        coopType: "804",
      };
      getCooperateUnitPage(params).then((res) => {
        this.coopList = res.data;
      });
    },
    showList(listNum) {
      this.showNewList1 = listNum == 1 || listNum == 0;
      this.showNewList2 = listNum == 2;

      this.titles.forEach((item, index) => {
        if (listNum == 1 || listNum == 0) {
          item.isSelected = index == 0 ? true : false;
        }
        if (listNum == 2) {
          item.isSelected = index == 1 ? true : false;
        }
      });
    },
    // 跳转列表
    toLink(categoryCode, tabcode) {
      console.log("categoryCode", categoryCode);
      if (!tabcode) { tabcode = categoryCode }
      let url = "/newsList?categoryId=" + categoryCode + "&linkType=2" + "&tabcode=" + tabcode
      this.$router.push(url);
      // let targetCode = '';
      // targetCode = Object.entries(codeTargetMapping).find((item) => { return item[1] == listName;})[0];
      // console.log("targetCode", targetCode);
      // this.$router.push({
      //   path: "/newsList?categoryId=" + targetCode + "&linkType=1",
      // });
    },
    //跳转详情
    toDetail(item, code) {
      // console.log("item,code", item,code);
      this.$router.push({
        path: "/newsList/newsDetail/" + item.articleId + '/' + code,
      });
    },
    //切换页面
    changePageClick() {
      this.loading = true;
    },
    teacherDetail(id) {
      this.$router.push({
        path: "/professor/detail/" + id,
      });
    },
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.path == "/") {
          this.displayPage = true;
        } else {
          this.displayPage = false;
        }
      },
      // 一进页面就执行
      immediate: true,
      // 深度观察监听
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/home/home.scss";
</style>
